import editor from "./editor";
import commonHelpers from "common/plugins/issues/topic_with_parameters_with_any_value";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
